import BaseApi from './BaseApi';

/**
 * PUSH通知トークン登録・更新APIのリクエストモデル
 */
export type PushTokenData = {
  /**
   * FCMから取得したプッシュ用トークン
   */
  pushToken: string;

  /**
   * PUSH通知の有効、無効を指定(true:有効 / false:無効)
   * - 有効：ログイン時
   * - 無効：ログアウト時
   */
  enabled: boolean;

  /**
   * Webプッシュ通知判別用
   */
  isWebPush: boolean;
};

/**
 * PUSH通知トークン登録・更新API
 */
class UpdatePushTokenApi extends BaseApi {
  async set(params: PushTokenData) {
    console.log({ paramspushToken: params.pushToken });
    return await this.execute('updatePushTokenApi', {
      method: 'POST',
      body: params
    }).then(({ status }) => {
      console.log({ status: status });
      status === 1;
    });
  }
}

export default UpdatePushTokenApi;
